import {RFPercentage, RFValue} from 'react-native-responsive-fontsize';
import styled from 'styled-components/native';
import Modal from 'react-native-modal';
import Feather from 'react-native-vector-icons/Feather';

import {Platform} from 'react-native';
import MapView from 'react-native-maps';
import FastImage from 'react-native-fast-image';
import Ionicons from 'react-native-vector-icons/Ionicons';
import {
  getBottomSpace,
  getStatusBarHeight,
  isIphoneX,
} from 'react-native-iphone-screen-helper';

export const Container = styled(Modal)`
  justify-content: flex-end;
  margin: 0;
`;

export const CloseButton = styled.TouchableOpacity`
  position: absolute;
  top: ${isIphoneX() ? getStatusBarHeight() : RFValue(20)}px;
  right: 24px;
`;
export const CloseButtonIcon = styled(Feather)`
  color: ${({theme}) => theme.colors.shape};
  font-size: ${RFValue(18)}px;
`;

export const ModalContent = styled.View`
  background-color: ${({theme}) => theme.colors.background};
  width: 100%;
  height: ${RFPercentage(56)}px;
  border-top-left-radius: 16px;
  border-top-right-radius: 16px;
  overflow: hidden;
`;

export const ContainerIcons = styled.View`
  flex-direction: row;
  align-items: center;
`;

export const ContainerStationHeader = styled.View`
  align-items: flex-end;
`;

export const ModalBody = styled.View`
  flex: 1;
  padding: 0 24px;
  margin-top: ${RFValue(12)}px;
  justify-content: space-between;
  margin-bottom: ${RFValue(16)}px;
`;

export const StationInfos = styled.View`
  flex-direction: row;

  align-items: center;
  justify-content: space-between;
`;

export const StationNameModal = styled.View`
  flex: 1;
  margin-right: ${RFValue(12)}px;
`;
export const StationName = styled.Text`
  color: ${({theme}) => theme.colors.title};
  font-size: ${RFValue(14)}px;

  font-family: ${({theme}) => theme.fonts.bold};
`;
export const StationAddress = styled.Text`
  color: ${({theme}) => theme.colors.text};
  font-size: ${RFValue(12)}px;
  font-family: ${({theme}) => theme.fonts.regular};
`;
export const DistanceContainer = styled.View`
  flex-direction: row;
  background-color: blue;
`;
export const DistanceIcon = styled(Feather)`
  color: ${({theme}) => theme.colors.primary};
  font-size: ${RFValue(16)}px;
  margin-right: ${RFValue(6)}px;
`;
export const Distance = styled.Text`
  color: ${({theme}) => theme.colors.title};
  font-size: ${RFValue(12)}px;
  font-family: ${({theme}) => theme.fonts.semibold};
`;
export const StationHeader = styled(MapView)`
  background: ${({theme}) => theme.colors.green_light};
  height: ${RFPercentage(20)}px;
  width: 100%;
  overflow: hidden;
`;
export const MarkerView = styled(FastImage)`
  width: ${RFValue(40)}px;
  height: ${RFValue(40)}px;
  border: 2px solid ${({theme}) => theme.colors.image_border};
  border-radius: ${RFValue(10)}px;
`;
export const ButtonNavigation = styled.TouchableOpacity`
  background-color: ${({theme}) => theme.colors.primary};
  height: ${RFValue(32)}px;
  padding: 0 ${RFValue(12)}px;
  margin-left: ${RFValue(20)}px;
  justify-content: center;
  align-items: center;
  border-radius: ${RFValue(24)}px;
  position: absolute;
  bottom: ${RFValue(12)}px;
  right: ${RFValue(12)}px;
  flex-direction: row;
`;
export const NavigationIcons = styled(Ionicons)`
  color: ${({theme}) => theme.colors.shape};
  margin-left: ${RFValue(5)}px;
  font-size: ${RFValue(14)}px;
`;
export const ContainerSubtitle = styled.View`
  flex-direction: row;
  align-items: center;
`;
export const IconSubtitle = styled(Ionicons)`
  color: ${({theme}) => theme.colors.primary};
  margin-right: ${RFValue(12)}px;
  font-size: ${RFValue(18)}px;
`;
export const TextSubtitle = styled.Text`
  color: ${({theme}) => theme.colors.black};
  font-size: ${RFValue(12)}px;
  flex: 1;
  font-family: ${({theme}) => theme.fonts.semibold};
`;
export const ButtonContainer = styled.View`
  flex-direction: row;
  width: 100%;
  align-items: center;
  justify-content: space-between;
`;
export const ButtonBack = styled.TouchableOpacity`
  height: ${RFValue(45)}px;
  width: 25%;
  justify-content: center;
  align-items: center;
  margin-right: ${RFValue(12)}px;
  padding-left: 4px;
  border-radius: ${RFValue(12)}px;
`;
export const ButtonBackText = styled.Text`
  color: ${({theme}) => theme.colors.title};
  font-size: ${RFValue(12)}px;
  font-family: ${({theme}) => theme.fonts.semibold};
`;

export const ButtonConfirm = styled.TouchableOpacity`
  background-color: ${({theme}) => theme.colors.primary};
  height: ${RFValue(35)}px;
  flex: 1;
  justify-content: center;
  align-items: center;
  border-radius: ${RFValue(26)}px;
`;
export const ButtonConfirmText = styled.Text`
  color: ${({theme}) => theme.colors.shape};
  font-size: ${RFValue(12)}px;
  font-family: ${({theme}) => theme.fonts.semibold};
`;

export const MapIconButton = styled.TouchableOpacity`
  margin-right: ${RFValue(12)}px;
  width: ${RFValue(43)}px;

  justify-content: center;
  align-items: center;
`;

export const OpenMapsContainer = styled.View``;

export const OpenMapIcons = styled.View`
  flex-direction: row;
  align-items: flex-start;
`;

export const MapIcon = styled.Image`
  width: ${RFValue(41)}px;
  border-radius: 30px;
  height: ${RFValue(41)}px;
`;

export const MapTitle = styled.Text`
  font-size: ${RFValue(9)}px;
  text-align: center;
  margin-top: 6px;
  line-height: ${RFValue(10)}px;
  color: ${({theme}) => theme.colors.title};
  font-family: ${({theme}) => theme.fonts.medium};
`;

export const OpenMapsTitle = styled.Text`
  color: ${({theme}) => theme.colors.title};
  font-size: ${RFValue(12)}px;
  margin-bottom: ${RFValue(8)}px;
  font-family: ${({theme}) => theme.fonts.semibold};
`;

export const ModalFooter = styled.View`
  padding: 0 24px;
  padding-bottom: ${RFValue(16)}px;
`;
